/*
  Pink & Red: two-line product titles (Prestige).
  "Axton Midi Dress In Sketching On Safari" shows as
  "Axton Midi Dress" over "in Sketching On Safari".
  Titles without " in " stay on one line.
  To keep a title on one line, add the start of it to EXCLUDE (lowercase).
*/
(function () {
  var SELECTORS = [
    '.product-card .product-title',
    '.horizontal-product-card .product-title',
    '.product-info .product-title',
    '.product-info .product-title a',
    '.line-item-info a[href*="/products/"]'
  ].join(', ');
  var EXCLUDE = ['meet me in'];

  function splitTitle(el) {
    if (el.getAttribute('data-split-done')) return;
    el.setAttribute('data-split-done', '1');
    if (el.children.length) return;

    var raw = (el.textContent || '').replace(/\s+/g, ' ').trim();
    if (!raw) return;
    var lower = raw.toLowerCase();
    for (var x = 0; x < EXCLUDE.length; x++) {
      if (lower.indexOf(EXCLUDE[x]) === 0) return;
    }

    var i = lower.lastIndexOf(' in ');
    if (i < 1) return;
    var style = raw.slice(0, i).trim();
    var print = raw.slice(i + 4).trim();
    if (!style || !print) return;

    var s1 = document.createElement('span');
    s1.className = 'pr-title-style';
    s1.textContent = style;
    var s2 = document.createElement('span');
    s2.className = 'pr-title-print';
    s2.textContent = 'in ' + print;
    el.textContent = '';
    el.appendChild(s1);
    el.appendChild(s2);
  }

  function run(root) {
    if (!root || !root.querySelectorAll) return;
    if (root.matches && root.matches(SELECTORS)) splitTitle(root);
    var els = root.querySelectorAll(SELECTORS);
    for (var i = 0; i < els.length; i++) splitTitle(els[i]);
  }

  function start() {
    run(document);
    if (window.MutationObserver) {
      new MutationObserver(function (mutations) {
        for (var m = 0; m < mutations.length; m++) {
          var added = mutations[m].addedNodes;
          for (var n = 0; n < added.length; n++) run(added[n]);
        }
      }).observe(document.body, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
